<template>
  <v-list dense>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Percentage Discount</v-list-item-title>
        <v-list-item-subtitle>Discount: {{ promoItem.percentDiscount }} %</v-list-item-subtitle>
        <v-list-item-subtitle>Remarks: {{ promoItem.remarks }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'PctDisc',
  props: {
    promoItem: { type: Object, required: true },
  },
}
</script>